export const YEATI_LOC_QUERY_KEYS = {
  products: {
    all: ["yeati-loc-products"] as const,
    lists: () => [...YEATI_LOC_QUERY_KEYS.products.all, "list"] as const,
    list: (filters: string) =>
      [...YEATI_LOC_QUERY_KEYS.products.lists(), filters] as const,
    details: () => [...YEATI_LOC_QUERY_KEYS.products.all, "detail"] as const,
    detail: (id: string) =>
      [...YEATI_LOC_QUERY_KEYS.products.details(), id] as const,
  },
  bookings: {
    all: ["yeati-loc-bookings"] as const,
    lists: () => [...YEATI_LOC_QUERY_KEYS.bookings.all, "list"] as const,
    list: (filters: string) =>
      [...YEATI_LOC_QUERY_KEYS.bookings.lists(), filters] as const,
    details: () => [...YEATI_LOC_QUERY_KEYS.bookings.all, "detail"] as const,
    detail: (id: string) =>
      [...YEATI_LOC_QUERY_KEYS.bookings.details(), id] as const,
    accountingLines: (bookingId: string, includeSettled: boolean) =>
      [
        ...YEATI_LOC_QUERY_KEYS.bookings.all,
        "accounting-lines",
        bookingId,
        includeSettled,
      ] as const,
    ledgerEntries: (bookingId: string, holderType?: string, holderId?: string) =>
      [
        ...YEATI_LOC_QUERY_KEYS.bookings.all,
        "ledger-entries",
        bookingId,
        holderType ?? null,
        holderId ?? null,
      ] as const,
    subsidyEvaluation: (bookingId: string) =>
      [
        ...YEATI_LOC_QUERY_KEYS.bookings.all,
        "subsidy-evaluation",
        bookingId,
      ] as const,
    history: (bookingId: string) =>
      [...YEATI_LOC_QUERY_KEYS.bookings.all, "history", bookingId] as const,
  },
  planning: {
    all: ["yeati-loc-planning"] as const,
    list: (filters: string) =>
      [...YEATI_LOC_QUERY_KEYS.planning.all, "list", filters] as const,
  },
  categories: { all: ["yeati-loc-categories"] as const },
  catalogCategories: {
    all: ["yeati-loc-catalog-categories"] as const,
    byCollection: (collectionId: string) =>
      [...YEATI_LOC_QUERY_KEYS.catalogCategories.all, collectionId] as const,
  },
  isbndb: {
    all: ["yeati-loc-isbndb"] as const,
    search: (query: string) =>
      [...YEATI_LOC_QUERY_KEYS.isbndb.all, "search", query] as const,
  },
  bulkImports: {
    all: ["yeati-loc-bulk-imports"] as const,
    active: () => [...YEATI_LOC_QUERY_KEYS.bulkImports.all, "active"] as const,
    detail: (id: string) =>
      [...YEATI_LOC_QUERY_KEYS.bulkImports.all, "detail", id] as const,
  },
  collections: {
    all: ["yeati-loc-collections"] as const,
    lists: () => [...YEATI_LOC_QUERY_KEYS.collections.all, "list"] as const,
    detail: (id: string) =>
      [...YEATI_LOC_QUERY_KEYS.collections.all, "detail", id] as const,
  },
  dashboard: {
    all: ["yeati-loc-dashboard"] as const,
    kpis: () => [...YEATI_LOC_QUERY_KEYS.dashboard.all, "kpis"] as const,
    recentBookings: () =>
      [...YEATI_LOC_QUERY_KEYS.dashboard.all, "recent-bookings"] as const,
  },
  settings: ["yeati-loc-settings"] as const,
  formTemplates: ["yeati-loc-form-templates"] as const,
  unavailabilities: {
    all: ["yeati-loc-unavailabilities"] as const,
    forItem: (itemId: string) =>
      [...YEATI_LOC_QUERY_KEYS.unavailabilities.all, itemId] as const,
  },
} as const;
